import { render, staticRenderFns } from "./overview-tab.vue?vue&type=template&id=06417849"
import script from "./overview-tab.vue?vue&type=script&lang=js"
export * from "./overview-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports